<template>
  <div v-loading="$wait.waiting(_uid)" class="card">
    <div v-if="event" class="card-content">
      <div class="text-right control-button-wrapper pt-xxs">
        <router-link :to="{ name: 'my_events@index' }">
          <button type="button" class="btn btn-primary btn-wd mr-5">
            Back
          </button>
        </router-link>

        <acl :roles="canActivateEvent()">
          <button
            v-show="event.deleted_at"
            type="button"
            class="btn btn-success btn-wd mr-5"
            :class="{ loading: $wait.waiting(_uid) }"
            @click="handleActivateEvent"
          >
            Restore
            <i
              v-show="$wait.waiting(_uid)"
              class="fas fa-circle-notch loading-icon"
            />
          </button>
        </acl>
        <acl :roles="canDeactivateEvent()">
          <button
            v-show="!event.deleted_at"
            type="button"
            class="btn btn-danger btn-wd mr-5"
            :class="{ loading: $wait.waiting(_uid) }"
            @click="handleDeactivateEvent"
          >
            Archive
            <i
              v-show="$wait.waiting(_uid)"
              class="fas fa-circle-notch loading-icon"
            />
          </button>
        </acl>

        <acl :roles="canEditEvent()">
          <router-link :to="{
            name: 'my_events@update',
            params: { id: routeParams.id },
          }">
            <button
              v-show="event.is_active"
              type="button" class="btn btn-info btn-fill btn-wd submit-button"
              :class="{ loading: $wait.waiting(_uid) }">
              Edit
              <i v-show="$wait.waiting(_uid)" class="fas fa-circle-notch loading-icon" />
            </button>
          </router-link>
        </acl>
      </div>

      <EventShow :event="event" @eventDownloadFile="eventDownloadFile" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MyService from "@app/services/my";
import "quill/dist/quill.core.css";
import EventShow from "@components/Events/Components/Show.vue";
import rolesConstants from "@/components/acl/roles";
import { getStorageData } from "@/utils/storage";
import parseSettings from "@providers/parseSettings";
import EventBus from '@app/utils/event-bus';

export default {
  components: {
    EventShow,
  },
  data() {
    return {
      event: {}
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    routeParams() {
      return this.$route.params;
    },
  },
  created() {
    this.ROLE_SUPER = rolesConstants.ROLE_SUPER;
    this.ROLE_ADMIN = rolesConstants.ROLE_ADMIN;
    this.ROLE_COMPANY_MANAGER = rolesConstants.ROLE_COMPANY_MANAGER;
    this.ROLE_TRAINING_MANAGER = rolesConstants.ROLE_TRAINING_MANAGER;
    this.ROLE_TRAINEE = rolesConstants.ROLE_TRAINEE;
    this.ROLE_SUPPORT = rolesConstants.ROLE_SUPPORT;
    this.ROLE_CTOPS = rolesConstants.ROLE_CTOPS;
  },
  beforeCreate() {
    EventBus.DownloadProgressBar.$on('onDownloadProgress', (data) => {
      console.log(data);
      this.$Progress.set(data.progress);
    });
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      this.event = await MyService.showEvent(this.routeParams.id);
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    parseSettings,
    canEditEvent() {
        const roleList = [];

      roleList.push(this.ROLE_COMPANY_MANAGER);
      roleList.push(this.ROLE_TRAINING_MANAGER);

      const company = getStorageData("company");
      const companySettings = this.parseSettings(company.settings);

      if (companySettings.events_documents) {
        roleList.push(this.ROLE_TRAINEE);
        return roleList;
      }

      return roleList;
    },
    canActivateEvent() {
      const roleList = [];

      roleList.push(this.ROLE_COMPANY_MANAGER);
      roleList.push(this.ROLE_TRAINING_MANAGER);
      
      return roleList;
    },
    canDeactivateEvent() {
      const roleList = [];

      roleList.push(this.ROLE_COMPANY_MANAGER);
      roleList.push(this.ROLE_TRAINING_MANAGER);
      
      return roleList;
    },
    async eventDownloadFile({ event, file }) {
      try {
        this.$wait.start(this._uid);
        const response = await MyService.downloadFile(event.id, file.id);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.original_name);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        this.$Progress.fail();
        this.addNewError(error);
      } finally {
        this.$Progress.finish();
        this.$wait.end(this._uid);
      }
    },
    async handleActivateEvent() {
      try {
        this.$wait.start(this._uid);

        const event = await MyService.activateEvent(this.event.id);

        this.$notify({
          message: "Event restored successfully!",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });

        this.event = event;

        // this.$router.push({
        //   name: "my_events@show",
        //   params: { id: event.id },
        // });
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    async handleDeactivateEvent() {
      try {
        this.$wait.start(this._uid);

        const event = await MyService.deactivateEvent(this.event.id);

        this.$notify({
          message: "Event archived successfully!",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });

        this.event = event;

        // this.$router.push({
        //   name: "my_events@show",
        //   params: { id: event.id },
        // });
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
  },
};
</script>

<style lang="scss">
.notes {
  ul {
    list-style-type: circle;
    padding: 0 3rem;
  }

  ol {
    padding: 0 3rem;
    list-style-type: decimal;
  }
}
</style>
